import { createApp } from 'vue'

import App from './App.vue'
import router from './router/index.js'
import store from './store/vuex-store'
import mitt from 'mitt';

import firebase from "firebase";

import "bootstrap/dist/js/bootstrap.min";
import "bootstrap/dist/css/bootstrap.min.css";



const app = createApp(App);
const emitter = mitt();
const analytics = firebase.analytics();

app.config.productionTip = false;
app.config.globalProperties.emitter = emitter;
app.use(analytics);
app.use(store);
app.use(router);
app.mount("#app");